import { MutationOptions, useMutation, useQuery } from "@tanstack/vue-query"

import { JoinPensionRecommendationsParams, KycPensionService } from "./pension.service"

export type JoinPensionRecommendations = Awaited<
  ReturnType<typeof KycPensionService.joinPensionRecommendations>
>
export const useJoinPensionRecommendations = (
  options?: MutationOptions<JoinPensionRecommendations, Error, JoinPensionRecommendationsParams>
) => {
  return useMutation<JoinPensionRecommendations, Error, JoinPensionRecommendationsParams>({
    mutationKey: ["KycPensionService.joinPensionRecommendations"],
    mutationFn: KycPensionService.joinPensionRecommendations,
    ...options,
  })
}
